import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-kanban-todolist-form', {
  mixins: [eventListenerMixin],

  connected() {
    this.cancel = this.querySelector('.button-cancel');
    this.listenTo(this.cancel, 'click', () => {
      this.remove();
    });
  },

  ready() {
    this.input = this.querySelector('.mdc-text-field__input');
    if (this.input) this.input.focus();
  },

  disconnected() {
    this.stopListening();
  },
});
